require.register("app/restaurant/Form", function(exports, require, module){
  $0
  
});

